var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchComponent),
      expression: "searchComponent"
    }],
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.Search == 0) ? _c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.Search = '1'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus plus"
  }), _vm._v(" Search\n      ")]) : _vm._e(), _vm._v(" "), (_vm.Search == 1) ? _c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.Search = '0'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus minus"
  }), _vm._v(" Search\n      ")]) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    class: ("" + (_vm.Search == '1' ? 'show' : 'hide')),
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Zone "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.zoneLoading
    },
    on: {
      "update:active": function($event) {
        _vm.zoneLoading = $event
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zone),
      expression: "zone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('zone')
    },
    attrs: {
      "name": "zone",
      "id": "zone"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getStateData]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.zoneList), function(zone_obj) {
    return _c('option', {
      attrs: {
        "isid": zone_obj.hubzoneid,
        "title": zone_obj.hubzonename
      },
      domProps: {
        "value": zone_obj.hubzonename
      }
    }, [_vm._v(_vm._s(zone_obj.hubzonename))])
  })], 2)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zone')),
      expression: "errors.has('zone')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Zone is required. ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.stateLoading
    },
    on: {
      "update:active": function($event) {
        _vm.stateLoading = $event
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "state",
      "id": "state"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getCityData]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.stateList), function(state_obj) {
    return _c('option', {
      attrs: {
        "isid": state_obj.stateid,
        "title": state_obj.statename
      },
      domProps: {
        "value": state_obj.statename
      }
    }, [_vm._v(_vm._s(state_obj.statename))])
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.cityLoading
    },
    on: {
      "update:active": function($event) {
        _vm.cityLoading = $event
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "city",
      "id": "city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.city = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.cityList), function(city_obj) {
    return _c('option', {
      attrs: {
        "isid": city_obj.cityid,
        "title": city_obj.cityname
      },
      domProps: {
        "value": city_obj.cityname
      }
    }, [_vm._v(_vm._s(city_obj.cityname))])
  })], 2)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("From Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "FromDate",
      "name": "FromDate",
      "type": "date",
      "placeholder": " Enter User Type"
    },
    model: {
      value: (_vm.FromDate),
      callback: function($$v) {
        _vm.FromDate = $$v
      },
      expression: "FromDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "fdate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("To Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "ToDate",
      "name": "ToDate",
      "type": "date",
      "placeholder": " Enter User Type"
    },
    model: {
      value: (_vm.ToDate),
      callback: function($$v) {
        _vm.ToDate = $$v
      },
      expression: "ToDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])])])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchComponent),
      expression: "searchComponent"
    }],
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', {
    staticStyle: {
      "height": "350px"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('i', {
    staticClass: " fa fa-bars barcolor"
  }), _vm._v(" "), _c('strong', [_vm._v("Zone  (" + _vm._s(_vm.zdate) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "height": "388px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.zoneLoading
    },
    on: {
      "update:active": function($event) {
        _vm.zoneLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, _vm._l((_vm.zoneAmtList), function(zone_obj) {
    return _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "card border-primary"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_vm._v(_vm._s(zone_obj.hubzonename))]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('i', {
      staticClass: "fa fa-rupee"
    }), _vm._v(" " + _vm._s(zone_obj.zoneamount))])])])
  }))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('i', {
    staticClass: " fa fa-bars barcolor"
  }), _vm._v(" "), _c('strong', [_vm._v("Graph  (" + _vm._s(_vm.resultdate) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.barComponent && !_vm.pieComponent && !_vm.amountComponent && !_vm.collectionComponent),
      expression: "!barComponent && !pieComponent && !amountComponent && !collectionComponent"
    }],
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "10%"
    }
  }, [_c('center', [_c('h4', [_vm._v("You do not have access to the selected city, state, or zone. Please choose a hub assigned to your account.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.barComponent),
      expression: "barComponent"
    }],
    staticClass: "col-md-6",
    staticStyle: {
      "margin-bottom": "20%"
    }
  }, [_c('center', [_c('div', {
    staticStyle: {
      "height": "15rem"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.barLoading
    },
    on: {
      "update:active": function($event) {
        _vm.barLoading = $event
      }
    }
  }), _vm._v(" "), _c('highcharts', {
    attrs: {
      "options": _vm.BarChart
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pieComponent),
      expression: "pieComponent"
    }],
    staticClass: "col-md-6",
    staticStyle: {
      "margin-bottom": "20%"
    }
  }, [_c('center', [_c('div', {
    staticStyle: {
      "width": "20rem",
      "height": "15rem"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.pieLoading
    },
    on: {
      "update:active": function($event) {
        _vm.pieLoading = $event
      }
    }
  }), _vm._v(" "), _c('highcharts', {
    attrs: {
      "options": _vm.piechart
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.amountComponent),
      expression: "amountComponent"
    }],
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.amountLoading
    },
    on: {
      "update:active": function($event) {
        _vm.amountLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables tableBodyScroll",
    attrs: {
      "width": "460"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Hub Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Total COD Amount")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Received ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Outstanding")])])])]), _vm._v(" "), _c('tbody', [(_vm.resultHubCollCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.hubCollectionList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.hubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-rupee"
    }), _vm._v(" " + _vm._s(data.total))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-rupee"
    }), _vm._v(" " + _vm._s(data.received))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-rupee"
    }), _vm._v(" " + _vm._s(data.outstanding))])])
  })], 2)])], 1), _vm._v(" "), _c('b-card-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collectionComponent),
      expression: "collectionComponent"
    }],
    staticClass: "card-headerfrm",
    attrs: {
      "deck": ""
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.collectionLoading
    },
    on: {
      "update:active": function($event) {
        _vm.collectionLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card text-dark bg-success my-2",
    staticStyle: {}
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('p', [_vm._v("Top Collection")]), _c('hr', {
    staticStyle: {
      "border-top": "1px solid rgb(0, 0, 0)"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.maxCOD.hubname))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" " + _vm._s(_vm.maxCOD.received))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card text-dark bg-danger my-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('p', [_vm._v("Least Collection")]), _c('hr', {
    staticStyle: {
      "border-top": "1px solid rgb(0, 0, 0)"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.minCOD.hubname))]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_c('i', {
    staticClass: "fa fa-rupee"
  }), _vm._v(" " + _vm._s(_vm.minCOD.received))])])])])], 1)], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.calcModal = false
      }
    },
    model: {
      value: (_vm.calcModal),
      callback: function($$v) {
        _vm.calcModal = $$v
      },
      expression: "calcModal"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Login Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCalcModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Zone")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popupZone),
      expression: "popupZone"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "popupZone",
      "id": "popupZone"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.popupZone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getStateData]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.zoneList), function(zone_obj) {
    return _c('option', {
      domProps: {
        "value": zone_obj.hubzonename
      }
    }, [_vm._v(_vm._s(zone_obj.hubzonename))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popupState),
      expression: "popupState"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "popupState",
      "id": "popupState"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.popupState = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getCityData]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.stateList), function(state_obj) {
    return _c('option', {
      domProps: {
        "value": state_obj.statename
      }
    }, [_vm._v(_vm._s(state_obj.statename))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PopupCity),
      expression: "PopupCity"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "PopupCity",
      "id": "PopupCity"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.PopupCity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getHubData]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.cityList), function(city_obj) {
    return _c('option', {
      domProps: {
        "value": city_obj.cityname
      }
    }, [_vm._v(_vm._s(city_obj.cityname))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hub),
      expression: "hub"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "hub",
      "id": "hub"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hub = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.hubList), function(hub_obj) {
    return _c('option', {
      domProps: {
        "value": hub_obj.HubName
      }
    }, [_vm._v(_vm._s(hub_obj.HubName))])
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "size": "vlg"
    }
  }, [_vm._v("Submit")]), _vm._v(" \n           "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "vlg"
    },
    on: {
      "click": _vm.closeCalcModal
    }
  }, [_vm._v("Cancel")])])])])], 1)], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a49a56f","hasScoped":true}!./src/views/components/dashboard/dashboard.component.html
// module id = 381
// module chunks = 1